import React, { useState, useRef, useEffect } from 'react'
import { useQuery } from 'jsonapi-react'
import styles from './TagList.module.css'
import jump from 'jump.js'
import StaticContent from 'app/utils/StaticContent'

export default function TagList(props) {
  const {
    heading = 'Explore Other Catering Types',
    baseUrl = '/',
    className,
    ...rest
  } = props

  const ref = useRef()
  const [open, setOpen] = useState()
  const toggle = () => setOpen(!open)

  useEffect(() => {
    if (open === false) {
      jump(ref.current, {
        duration: 0,
      })
    }
  }, [open])

  return (
    <section
      ref={ref}
      {...rest}
      className={[
        className,
        'bg-navy text-white text-center pt-16 pb-20',
      ]}
    >
      <div className={[styles.container, open && styles.open]}>
        <h2 className="font-platform mb-10 text-3xl lg:text-4xl">
          {heading}
        </h2>
        <div className={styles.cover}>
          <StaticContent>
            <Tags baseUrl={baseUrl} />
          </StaticContent>
        </div>
        <button
          className="btn text-white border-2 border-white font-platform text-xl px-10 py-3"
          onClick={() => toggle()}
        />
      </div>
    </section>
  )
}

function Tags({ baseUrl }) {
  const query = useQuery(['tags', {
    sort: 'name',
    fields: {
      tags: ['name', 'slug']
    },
    page: {
      size: 999,
    }
  }], {
    hydrate: false
  })

  if (query.isLoading) {
    return null
  }

  if (!query.data?.length) {
    return null
  }

  return (
    <ul>
      {query.data.map((tag, index) => (
        <li key={index}>
          <a href={baseUrl + '/' + tag.slug + '/'}>{tag.name}</a>
        </li>
      ))}
    </ul>
  )
}
